import React from "react";
import "./App.scss";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { HelmetProvider, Helmet } from "react-helmet-async";
import AOS from "aos";
import "aos/dist/aos.css";

import ProgressBar from "./components/partials/Animations/ProgressBar";
import CustomCursor from "./components/partials/Animations/CustomCursor";
import ScrolltoTop from "./components/partials/ScrolltoTop/ScrolltoTop";
import ScrollToTopOnLoad from "./components/partials/ScrolltoTop/ScrollToTopOnLoad";

import Navbar from "./components/partials/Navbar/Navbar";
import Home from "./components/pages/Home";
import AboutUs from "./components/pages/AboutUs";
import Services from "./components/pages/Services";
import MeetTheTeam from "./components/pages/MeetTheTeam";
import OurWork from "./components/pages/OurWork";
import ContactUs from "./components/pages/ContactUs";
import Thankyou from "./components/pages/Thankyou";
import Footer from "./components/partials/Footer/Footer";
import Omnix from "./components/pages/Omnix";
import Concord from "./components/pages/Concord";
import Intelihire from "./components/pages/Intelihire";
import PageTracker from "./components/pageTracker/PageTracker";
import AIDevelopment from "./components/pages/AIDevelopment";
import AOSWrapper from "./components/aosWrapper/AOSWrapper";
import OffshoreDevelopment from "./components/pages/OffshoreDevelopment";
import CustomDevelopment from "./components/pages/CustomDevelopment";
import ExdChatbot from "./components/includes/Chatbot/Chatbot";
import NewHome from "./components/pages/NewHome";
import Homee from "./components/includes/NewHomee/Homee";
import Careers from "./components/pages/Careers";
import JobDetails from "./components/pages/JobDetails";
import AIReadinessSurvey from "./components/pages/AIReadinessSurvey";

AOS.init({
  once: true, // keep it true if you want to load AOS animations only once, otherwise set it to false
});

const App = () => {
    //  var devUrl = "http://localhost:3000/";
    // var devUrl = "http://devdigital.exdnow.com/exd-digital/";
  var devUrl = "https://www.exddigital.com/";
// var devUrl = "http://voxpro.site/";
  
  return (
      // <Router basename="/exd-digital">
    <HelmetProvider>
       <Helmet
          defaultTitle="ExD Digital"
          titleTemplate="%s | ExD Digital"
          defer={false}
          />
        
        <Router basename="/">
        <PageTracker />
        <div className="div">
          {/* call to te progress bar on all pages */}
          <ProgressBar />
          {/* call to custom cursor all pages */}
          <CustomCursor />
          {/* scroll to top button */}
          <ScrolltoTop />
          {/*  scroll to top on page load */}
          <ScrollToTopOnLoad />

          <div className="body">
            {/* <NewHome/> */}
            <Navbar url={devUrl} />
             <ExdChatbot/>

            <div className="wrap">
              <AOSWrapper>
                <Routes>
                  <Route path="/"  element={<Homee devUrl={devUrl} />} />
                  <Route
                    path="/about-us"
                    exact
                    element={<AboutUs devUrl={devUrl} />}
                  />
                  <Route
                    path="/services"
                    exact
                    element={<Services devUrl={devUrl} />}
                  />
                  <Route
                    path="/meet-the-team"
                    exact
                    element={<MeetTheTeam devUrl={devUrl} />}
                  />
                  <Route
                    path="/our-work"
                    exact
                    element={<OurWork devUrl={devUrl} />}
                  />
                  <Route
                    path="/contact-us"
                    exact
                    element={<ContactUs devUrl={devUrl} />}
                  />
                  <Route
                    path="/omnix"
                    exact
                    element={<Omnix devUrl={devUrl} />}
                  />
                  <Route
                    path="/concord"
                    exact
                    element={<Concord devUrl={devUrl} />}
                  />

                  <Route
                    path="/intelihire"
                    exact
                    element={<Intelihire devUrl={devUrl} />}
                  />

                  <Route
                    path="/ai-development"
                    exact
                    element={<AIDevelopment devUrl={devUrl} />}
                  />

                  <Route
                    path="/offshore-software-development"
                    exact
                    element={<OffshoreDevelopment devUrl={devUrl} />}
                  />

                  <Route
                    path="/custom-software-development"
                    exact
                    element={<CustomDevelopment devUrl={devUrl} />}
                  />

                  <Route
                    path="/thankyou"
                    exact
                    element={<Thankyou devUrl={devUrl} />}
                  />

                  <Route
                    path="/home2"
                    exact
                    element={<Homee devUrl={devUrl} />}
                  />

                  <Route
                    path="/careers"
                    exact
                    element={<Careers devUrl={devUrl} />}
                  />

                  <Route
                    path="/careers/:jobId"
                    exact
                    element={<JobDetails devUrl={devUrl} />}
                  />

                  <Route
                    path="/ai-readiness-survey"
                    exact
                    element={<AIReadinessSurvey />}
                  />
                </Routes>
              </AOSWrapper>
            </div>

            <Footer />
          </div>
            
        </div>
      </Router>
    </HelmetProvider>
  );
};

export default App;
